<template>
  <Modal
    :no-exit-on-backdrop="true"
    :modal="phoneModalRef"
    :steps="[{ component: PhoneModalContent, id: 'ask-phone' }]"
  />
</template>

<script lang="ts" setup>
import PhoneModalContent from '@/features/ui/components/layout/phone-modal/phone-modal-content/phone-modal-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetPhoneModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const phoneModalRef = selectGetPhoneModal(modalsStore)
</script>
